import { UserGroupServiceMock } from "./user_group.types";

export const mockUserGroupService = (): UserGroupServiceMock => ({
  addMembers: jest.fn(),
  removeMembers: jest.fn(),
});
